import React from 'react';
import { startOfDay, subDays, subMonths, getDate } from 'date-fns';
import { BaseDateInput } from 'src/components/enterprise/components/BaseDateInput/BaseDateInput';

interface StartDateControlProps {
  name: string;
  id: string;
}

export const StartDateControl: React.FC<StartDateControlProps> = ({
  name,
  id,
}) => {
  const today = startOfDay(new Date());
  const initialMonth = getDate(today) === 1 ? subMonths(today, 1) : today;

  return (
    <BaseDateInput
      id={id}
      name={name}
      label="Start Date *"
      blockWidth
      rules={{
        required: 'Start Date is required',
      }}
      disabledDays={{
        after: subDays(today, 1),
      }}
      initialMonth={initialMonth}
    />
  );
};
